import { stVars } from '../../framework/colors.st.css';
export var iconColorByEditor = {
  'B1-CE': stVars['gc-color-b1'],
  'B1-RE': stVars['gr-color-b1'],
  'link-CE': stVars['gc-color-b1'],
  'link-RE': stVars['gr-color-b1'],
  'B2-CE': stVars['gc-color-b2'],
  'B2-RE': stVars['gr-color-b2'],
  'B3-CE': stVars['gc-color-b3'],
  'B3-RE': stVars['gr-color-b3'],
  'B4-CE': stVars['gc-color-b4'],
  'B4-RE': stVars['gr-color-b4'],
  'B5-CE': stVars['gc-color-b5'],
  'B5-RE': stVars['gr-color-b5'],
  'R1-CE': stVars['gc-color-r1'],
  'R1-RE': stVars['gr-color-r1'],
  'alert-CE': stVars['gc-color-r1'],
  'alert-RE': stVars['gr-color-r1'],
  'R2-CE': stVars['gc-color-r2'],
  'R2-RE': stVars['gr-color-r2'],
  'R3-CE': stVars['gc-color-r3'],
  'R3-RE': stVars['gr-color-r3'],
  'R4-CE': stVars['gc-color-r4'],
  'R4-RE': stVars['gr-color-r4'],
  'P1-CE': stVars['gc-color-p1'],
  'P1-RE': stVars['gr-color-p1'],
  'premium-CE': stVars['gc-color-p1'],
  'premium-RE': stVars['gr-color-p1'],
  'P2-CE': stVars['gc-color-p2'],
  'P2-RE': stVars['gr-color-p2'],
  'P3-CE': stVars['gc-color-p3'],
  'P3-RE': stVars['gr-color-p3'],
  'P4-CE': stVars['gc-color-p4'],
  'P4-RE': stVars['gr-color-p4'],
  'Y1-CE': stVars['gc-color-y1'],
  'Y1-RE': stVars['gr-color-y1'],
  'warning-CE': stVars['gc-color-y1'],
  'warning-RE': stVars['gr-color-y1'],
  'Y2-CE': stVars['gc-color-y2'],
  'Y2-RE': stVars['gr-color-y2'],
  'Y3-CE': stVars['gc-color-y3'],
  'Y3-RE': stVars['gr-color-y3'],
  'Y4-CE': stVars['gc-color-y4'],
  'Y4-RE': stVars['gr-color-y4'],
  'O1-CE': stVars['gc-color-o1'],
  'O1-RE': stVars['gr-color-o1'],
  'urgent-CE': stVars['gc-color-o1'],
  'urgent-RE': stVars['gr-color-o1'],
  'O2-CE': stVars['gc-color-o2'],
  'O2-RE': stVars['gr-color-o2'],
  'O3-CE': stVars['gc-color-o3'],
  'O3-RE': stVars['gr-color-o3'],
  'O4-CE': stVars['gc-color-o4'],
  'O4-RE': stVars['gr-color-o4'],
  'G1-CE': stVars['gc-color-g1'],
  'G1-RE': stVars['gr-color-g1'],
  'success-CE': stVars['gc-color-g1'],
  'success-RE': stVars['gr-color-g1'],
  'G2-CE': stVars['gc-color-g2'],
  'G2-RE': stVars['gr-color-g2'],
  'G3-CE': stVars['gc-color-g3'],
  'G3-RE': stVars['gr-color-g3'],
  'G4-CE': stVars['gc-color-g4'],
  'G4-RE': stVars['gr-color-g4'],
  'D1-CE': stVars['gc-color-d1'],
  'D1-RE': stVars['gr-color-d1'],
  'standard-CE': stVars['gc-color-d1'],
  'standard-RE': stVars['gr-color-d1'],
  'D2-CE': stVars['gc-color-d2'],
  'D2-RE': stVars['gr-color-d2'],
  'secondary-CE': stVars['gc-color-d2'],
  'secondary-RE': stVars['gr-color-d2'],
  'D3-CE': stVars['gc-color-d3'],
  'D3-RE': stVars['gr-color-d3'],
  'D35-CE': stVars['gc-color-d35'],
  'D35-RE': stVars['gr-color-d4'],
  'placeholder-CE': stVars['gc-color-d35'],
  'placeholder-RE': stVars['gr-color-d4'],
  'D4-CE': stVars['gc-color-d4'],
  'D4-RE': stVars['gr-color-d5'],
  'secondary-light-CE': stVars['gc-color-d4'],
  'secondary-light-RE': stVars['gr-color-d5'],
  'D5-CE': stVars['gc-color-d5'],
  'D5-RE': stVars['gr-color-d6'],
  'D6-CE': stVars['gc-color-d6'],
  'D6-RE': stVars['gr-color-d7'],
  'standard-light-CE': stVars['gc-color-d6'],
  'standard-light-RE': stVars['gr-color-d7'],
  'dis1-CE': stVars['gc-color-dis1'],
  'dis1-RE': stVars['gr-color-x1'],
  'disabled-CE': stVars['gc-color-dis1'],
  'disabled-RE': stVars['gr-color-x1'],
  'dis2-CE': stVars['gc-color-dis2'],
  'dis2-RE': stVars['gr-color-x2'],
  'dis3-CE': stVars['gc-color-dis4'],
  'dis3-RE': stVars['gr-color-x3'],
  'dis4-CE': stVars['gc-color-dis5'],
  'dis4-RE': stVars['gr-color-x4']
};